import styled from 'styled-components';
import {
  SectionParent,
  BlueButton,
  H1,
} from '../../../components/StyledComponents';

import React from 'react';
import { navigate, StaticQuery, graphql } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import { Title } from '../HomePage/HomepageSectionOne';

const ImgItem = styled(GatsbyImage)`
  width: 125%;
  margin-left: -10%;
  margin-top: 3.5rem;
  @media (min-width: 800px) and (max-width: 1100px) {
    height: 80%;
  }
  @media (max-width: 1100px) {
    height: 80%;
    width: 125%;
  }
  @media (max-width: 768px) {
    margin-top: 0rem;
    width: calc(100%);
    height: 80%;
    margin-left: 1rem;
  }
  @media (max-width: 520px) {
    margin-left: 0.5rem;
    width: calc(100%);
    height: 80%;
  }
  img {
    object-fit: contain !important;
  }
`;

const BlueButtonNew = styled(BlueButton)`
  margin-left: 3.5rem;
  @media (max-width: 520px) {
    margin-left: 1rem;
  }
`;
const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  padding-top: 6rem !important;
  padding-bottom: 5rem;
  background-size: contain;
  background-color: #1c233c;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 8rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(3, 1fr);
  padding-left: 5rem;
  display: grid;
  @media (max-width: 768px) {
    padding-left: 0rem;
  }
`;

const SectionOneTitle = styled(Title)`
  color: #ffffff;
  margin-left: 3rem;
  @media (max-width: 768px) {
    text-align: center;
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    padding: 0 3rem;
    margin-left: 0;
  }
  @media (max-width: 375px) {
    padding: 0;
    font-size: 27px;
  }
`;

const GridRight = styled.div`
  grid-column: span 2;
  padding-right: 3rem;
  padding-left: 3rem;
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 1100px) {
    margin-top: 7rem;
    padding-right: 0rem;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;
const GridLeft = styled.div`
  grid-column: span 1;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 3;
    padding-left: 0;
    justify-self: center;
  }
  @media (max-width: 520px) {
    width: 80%;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  margin-left: 3rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #ffffff;
  @media (max-width: 768px) {
    text-align: center;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
  }
  @media (max-width: 520px) {
    padding: 0 1rem;
  }
  @media (max-width: 350px) {
    padding: 0;
  }
`;

const BlueButtonWrapper = styled.div`
  margin-left: -10px;
  margin-top: 24px;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

export default class TestSectionOne extends React.Component<any, any> {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            hero: file(relativePath: { eq: "v2/png/Testhero.png" }) {
              childImageSharp {
                fluid(quality: 95) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <div>
            <SectionOne>
              <SectionItemContainer>
                <GridLeft>
                  <ImgItem
                    alt="Your App, Your Devices"
                    loading="lazy"
                    fluid={data.hero.childImageSharp.fluid}
                  />
                </GridLeft>
                <GridRight>
                  <SectionOneTitle>
                    Test Android Applications on Real Devices
                  </SectionOneTitle>
                  <HeroSubTitle style={{ paddingTop: '1rem' }}>
                    Esper Test Lab is built to help Android Developers. Now you
                    can test your application performance and behavior on a wide
                    variety of real and virtual devices. This ensures your
                    application is compatible with all device configurations and
                    your backend scales easily on a single platform!
                  </HeroSubTitle>
                  <BlueButtonWrapper>
                    <BlueButtonNew
                      id="test__your_android_application"
                      onClick={() => navigate('/signup')}
                    >
                      Test your Android application
                    </BlueButtonNew>
                  </BlueButtonWrapper>
                </GridRight>
              </SectionItemContainer>
            </SectionOne>
          </div>
        )}
      />
    );
  }
}
